import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home.tsx";
import Login from "./pages/Login.tsx";
import Register from "./pages/Register.tsx";
import ForgotPassword from "./pages/ForgotPassword.tsx";
import ChangePassword from "./pages/ChangePassword.tsx";
import Questions from "./pages/Questions.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import PracticeExam from "./pages/PracticeExam.tsx";
import Profile from "./pages/Profile.tsx";
import Privacy from "./pages/Privacy.tsx";
import Terms from "./pages/Terms.tsx";
import NotFound from "./pages/NotFound.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import Footer from "./components/Footer.tsx";
import Seo from "./components/Seo.tsx";

const App: React.FC = () => (
  <Router>
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <ErrorBoundary>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Seo title="Exams Revision | AI-Powered 11+ Practice Quizzes and Tutoring" description="Prepare for your exams with AI-powered quizzes, instant feedback and smart tutoring. Practise, learn and track progress." path="/" />
                <Home />
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                <Seo title="Log In | Exams Revision" description="Log in to Exams Revision to continue your practice quizzes and track your progress." path="/login" />
                <Login />
              </>
            }
          />
          <Route
            path="/register"
            element={
              <>
                <Seo title="Create an Account | Exams Revision" description="Sign up to Exams Revision for AI-powered practice quizzes, instant feedback and progress tracking." path="/register" />
                <Register />
              </>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <>
                <Seo title="Reset Your Password | Exams Revision" description="Reset your Exams Revision password." path="/forgot-password" />
                <ForgotPassword />
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                <Seo title="Privacy Policy | Exams Revision" description="How Exams Revision collects, uses and protects your personal data." path="/privacy" />
                <Privacy />
              </>
            }
          />
          <Route
            path="/terms"
            element={
              <>
                <Seo title="Terms and Conditions | Exams Revision" description="The terms and conditions for using Exams Revision." path="/terms" />
                <Terms />
              </>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <Seo title="ChangePassword | Exams Revision" description="Exams Revision account area." path="/" noindex />
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/questions"
            element={
              <ProtectedRoute>
                <Seo title="Questions | Exams Revision" description="Exams Revision account area." path="/" noindex />
                <Questions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Seo title="Dashboard | Exams Revision" description="Exams Revision account area." path="/" noindex />
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practice-exam"
            element={
              <ProtectedRoute>
                <Seo title="PracticeExam | Exams Revision" description="Exams Revision account area." path="/" noindex />
                <PracticeExam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Seo title="Profile | Exams Revision" description="Exams Revision account area." path="/" noindex />
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <>
                <Seo title="Page Not Found | Exams Revision" description="This page does not exist." path="/" noindex />
                <NotFound />
              </>
            }
          />
        </Routes>
        </ErrorBoundary>
      </div>
      <Footer />
    </div>
  </Router>
);

export default App;
